<template>
  <main>
    <md-app>
      <md-app-toolbar>
        <Bar />
      </md-app-toolbar>
      <md-app-drawer md-permanent="full">
        <Menu />
      </md-app-drawer>
      <md-app-content>
        <div class="breadcrumbs">
          <router-link to="/admin">Home</router-link> / <router-link to="/admin/projects-moderation">Projetos moderação</router-link> / Form
        </div>
        <Form :moderation="true" />
      </md-app-content>
    </md-app>
    <vue-easy-lightbox
      :visible="modal_show"
      :imgs="[modal_img]"
      :index="modal_index"
      @hide="handleHideImage"
    ></vue-easy-lightbox>
  </main>
</template>

<script>
import Bar from '../../../components/admin/Bar';
import Menu from '../../../components/admin/Menu';
import Form from '../../../components/admin/project/Form';
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: "AdminProjectModerationForm",
  components: {
    Menu,
    Form,
    Bar,
    VueEasyLightbox
  },
  methods: {
    handleHideImage() {
      this.$store.commit("handleHideImage");
    },
  },
  computed: {
    modal_show: {
      get() {
        console.log('get modal_show')
        return this.$store.state.modal_show;
      },
      set() {}
    },
    modal_img: {
      get() {
        return this.$store.state.modal_img;
      },
      set() {}
    },
    modal_index: {
      get() {
        return this.$store.state.modal_index;
      },
      set() {}
    },
  }
};
</script>
